require('angular').module('wowApp.shop')
    .directive('bwsInfiniteScroll', ['$window', 'jQuery', require('./infinite-scroll-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/infinate-scroll/index.js
 **/